import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Level } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { LevelForm } from "../LevelForm/LevelForm";
import "./LevelItem.scss";

const levelController = new Level();

export function LevelItem(props) {
  const { level, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateLevel = () => {
    setTitleModal(`Actualizar nivel: ${level.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el nivel ${level.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await levelController.deleteLevel(accessToken, level.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="level-item">
        <div className="level-item__info">
          <span className="level-item__info-name">{level.name}</span>
        </div>
        <div>
          <Popup
            content="Actualizar nivel"
            trigger={
              <Button icon primary onClick={openUpdateLevel}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar nivel"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <LevelForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          level={level}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
